import React, { Component } from "react";
import Table from 'antd/lib/table';
import httpRequest from "apis/httpRequest";
import { MY_LIB_URL } from "actions/types"
const columns = [
  {
    title: '书本名',
    dataIndex: 'TSM'
  },
  {
    title: '借出时间',
    dataIndex: 'JCSJ',
  },
  {
    title: '归还时间',
    dataIndex: 'GHSJ',
  },
  {
    title: '超期罚款',
    dataIndex: 'FK'
  }
];

class Borrow extends Component {
  state = {
    libData: [],
  }
  componentDidMount() {
    httpRequest.get(MY_LIB_URL).then(res => {
      if (res.data.payload) {
        let libData = res.data.payload.datas
        this.setState({ libData: libData })
      }
    })
  }
  render() {
    const { libData } = this.state
    return (
      <div className="personal-grade">
        <div className="personal-grade-content">
          <div className="title">借阅查询</div>
          <div className="table">
            <Table columns={columns} dataSource={libData} bordered={true} pagination={{
              // total: 20,
              // onChange: (page) => { console.log(page) },
              style: {
                float: "left"
              },
              className: "gafa-pagination"
            }} />
          </div>
        </div>
      </div>
    )
  }
}

export default Borrow